class GuestAuthDrawerRegister extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.form = this.querySelector('form');
    this.formWrapper = this.querySelector('#account-register-form');
    this.creating = this.querySelector('#account-register-creating');

    this.emailInput = this.querySelector('input[name="customer[email]"]');
    this.firstNameInput = this.querySelector('input[name="customer[first_name]"]');
    this.lastNameInput = this.querySelector('input[name="customer[last_name]"]');
    this.passwordInput = this.querySelector('input[name="customer[password]"]');

    this.submitButton = this.querySelector('button[type="submit"]');

    this.firstNameSpan = document.querySelectorAll('.prestige-membership-card span.first_name');
    this.lastNameSpan = document.querySelectorAll('.prestige-membership-card span.last_name');

    this.formErrorMessage = this.getAttribute('data-form-error');

    this.debouncedCheckFormValidity = window.debounce(() => this.checkFormValidity(), 300);

    this.bindEvents();
    this.checkFormValidity();

    this.isEventSignup = this.dataset.eventSignup === 'true';
  }

  bindEvents() {
    this.syncInputWithSpans(this.firstNameInput, this.firstNameSpan);
    this.syncInputWithSpans(this.lastNameInput, this.lastNameSpan);

    [this.emailInput, this.firstNameInput, this.lastNameInput, this.passwordInput].forEach((input) => {
      if (input) {
        input.addEventListener('blur', this.debouncedCheckFormValidity);
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.handleSubmit();
        return false;
      });
    }
  }

  syncInputWithSpans(input, spans) {
    if (input && spans) {
      input.addEventListener('input', (e) => {
        spans.forEach((span) => (span.textContent = e.target.value || ''));
      });
    }
  }

  async handleSubmit() {
    if (this.querySelector('.error-message')) {
      this.querySelector('.error-message').remove();
    }

    const email = this.emailInput?.value || '';
    const firstName = this.firstNameInput?.value || '';
    const lastName = this.lastNameInput?.value || '';
    const password = this.passwordInput?.value || '';

    const isFormValid =
      this.validateEmail(email) &&
      (this.isEventSignup || this.validateName(firstName)) &&
      (this.isEventSignup || this.validateName(lastName)) &&
      this.validatePassword(password);

    if (!isFormValid) {
      const errorMessage = this.errorMessage(this.formErrorMessage);
      this.submitButton.insertAdjacentElement('afterend', errorMessage);

      return false;
    }

    const cartAttributes = {
        _onboarding_preferences_step_after_signup: 'true',
      };

    if (!('startViewTransition' in document)) {
      await this.setCartAttribute(cartAttributes);
      this.form.submit();
      return;
    }

    if (!document.getElementById('vt-opt-in')) {
      const s = document.createElement('style');
      s.id = 'vt-opt-in';
      s.textContent = '@view-transition { navigation: auto; }';
      document.head.appendChild(s);
    }

    this.formWrapper.style.transition = 'opacity 1000ms ease-in-out, transform 1000ms ease-in-out';
    this.formWrapper.style.transform = 'translateY(-20px)';
    this.formWrapper.style.opacity = '0';

    this.creating.classList.remove('!hidden');
    requestAnimationFrame(() => {
      this.creating.style.transform = 'translateY(0px)';
      this.creating.style.opacity = '1';
    });

    try {
      cartAttributes._vt_onboarding_preferences_step_after_signup = 'true',
      await this.setCartAttribute(cartAttributes);

      document.startViewTransition(() => {
        this.form.submit();
      });
    } catch (error) {
      console.error('Failed to set cart attribute:', error);

      this.creating.style.transform = 'translateY(-20px)';
      this.creating.style.opacity = '0';

      requestAnimationFrame(() => {
        this.creating.classList.add('!hidden');

        this.formWrapper.style.transform = 'translateY(0px)';
        this.formWrapper.style.opacity = '1';

        const errorMessage = this.errorMessage('An unexpected error occurred. Please try again or contact support.');
        this.submitButton.insertAdjacentElement('afterend', errorMessage);
      });
    }

    return false;
  }

  errorMessage(message) {
    const errorDiv = document.createElement('div');
    errorDiv.classList.add('error-message', 'text-red-500', 'text-sm', 'mt-2', 'col-span-full');
    errorDiv.textContent = message;
    return errorDiv;
  }

  async setCartAttribute(attributes) {
    if (!attributes || typeof attributes !== 'object') {
      return;
    }

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ attributes }),
    });

    if (!response.ok) {
      throw new Error(`Failed to update cart: ${response.status} ${response.statusText}`);
    }

    return response;
  }

  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  validatePassword(password) {
    // Basic password validation - at least 5 characters
    return password && password.length >= 5;
  }

  validateName(name) {
    // Name should not be empty and contain at least 1 characters
    return name && name.trim().length >= 1;
  }

  checkFormValidity() {
    if (!this.submitButton) return;

    const email = this.emailInput?.value || '';
    const firstName = this.firstNameInput?.value || '';
    const lastName = this.lastNameInput?.value || '';
    const password = this.passwordInput?.value || '';

    const isFormValid =
      this.validateEmail(email) &&
      (this.isEventSignup || this.validateName(firstName)) &&
      (this.isEventSignup || this.validateName(lastName)) &&
      this.validatePassword(password);

    if (isFormValid) {
      if (this.querySelector('.error-message')) {
        this.querySelector('.error-message').remove();
      }
    }
  }
}

customElements.define('guest-auth-drawer-register', GuestAuthDrawerRegister);
